import React from "react";
import classnames from "classnames";
import { compose, withProps, defaultProps, setDisplayName, withState, withHandlers } from "recompose";
import { find, uniq, get, includes, compact, xor } from "lodash";
import Popper from '../popper/Popper'
import { Input } from "@wds/input";
import { InputGroup, InputGroupAddon } from "@wds/input-group";
import { IconSearch } from "@wds/icons";
import { Label } from "@wds/label";

const enhance = compose(defaultProps({
    placeholder: "Select a value",
    emptyPlaceholder: "No items to be shown",
    items: [],
    isMultiple: false,
    selectedText: " selected"
}), withState("searchString", "setSearchString", ""), 
// modify items prop by searchString
withProps(function (props) { return ({
    activeItem: find(props.items, { value: props.value }),
    items: props.items.filter(function (item) {
        return (typeof item.label === "string" &&
            includes(item.label.toLocaleLowerCase(), props.searchString.toLocaleLowerCase()));
    })
}); }), withProps(function (props) { return ({
    groups: props.groups || uniq(props.items.map(function (item) { return item.group; })) || []
}); }), withState("activeGroup", "setActiveGroup", function (props) {
    return get(props.activeItem, "group", props.groups[0]);
}), withProps(function (props) { return ({
    groupedItems: props.items.filter(function (item) {
        if (props.isGrouped) {
            return item.group === props.activeGroup;
        }
        else {
            return true;
        }
    }),
    buttonText: (function () {
        if (props.activeItem) {
            return props.activeItem.label;
        }
        if (props.items.length === 0) {
            return props.emptyPlaceholder;
        }
        if (Array.isArray(props.value) && props.value.length > 0) {
            return props.value.length + props.selectedText;
        }
        return props.placeholder;
    })()
}); }), withHandlers({
    onItemClick: function (props) { return function (_a) {
        var value = _a.value, closePopper = _a.closePopper;
        return function () {
            if (props.isMultiple) {
                props.onChange(uniq(compact(xor(props.value, [value]))));
            }
            else {
                props.onChange(value);
                closePopper();
            }
        };
    }; }
}), setDisplayName("AdvancedSelect"));

export const AdvancedSelect = enhance(function (props) {
    const styleModifier = {
        name: 'positioner',
        enabled: true,
        phase: 'afterWrite',
        fn(_a) {
            var popper = _a.state.elements.popper, width = _a.state.elements.reference.offsetWidth;
            popper.style.minWidth = width + "px"; // min width should be the trigger's width
        },
    };
    const positionModifier = {
        name: 'offset',
        options: {
            offset: 1
        }
    };
    return (
        <Popper
            options={{
                placement: "bottom-start",
                modifiers: [positionModifier, styleModifier]
            }}
            renderRef={({ setReference, toggle }) => (
                <>
                    {props.label && <Label>{props.label}</Label>}
                    {<button type="button" ref={setReference} onClick={toggle} className={classnames("sui-advanced-select__trigger", props.className)} style={props.style} disabled={props.disabled}>{props.buttonText}</button>}
                </>
            )}
            renderPop={({ setPop, close }) => (
                    <>
                    {(props.items.length > 0 || props.isSearchable || props.renderFooter) && (
                        <div ref={setPop} className="sui-advanced-select__menu">
                            {props.isSearchable && (
                                <div className="sui-advanced-select__search">
                                    <InputGroup stretched>
                                        <Input value={props.searchString} onChange={(e) => {props.setSearchString(e.target.value)}} />
                                        <InputGroupAddon>
                                            <IconSearch />
                                        </InputGroupAddon>
                                    </InputGroup>
                                </div>
                            )}
                            <div style={props.groupsItemsStyle} className="sui-advanced-select__groups-items">
                                {props.isGrouped && (
                                    <div className="sui-advanced-select__groups" style={props.groupsStyle}>
                                        {props.groups.map((group) => (
                                            <div
                                                key={(props.activeItem && props.activeItem.value) + "_" + group}
                                                onClick={() => props.setActiveGroup(group)}
                                                className={classnames("sui-advanced-select__item", {
                                                    "sui-advanced-select__item--active": props.activeGroup === group
                                                })}
                                            >
                                                {group}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="sui-advanced-select__items">
                                    {props.groupedItems.map((item) => (
                                        <div
                                            key={(props.activeItem && props.activeItem.value) + "_" + item.value}
                                            onClick={props.onItemClick({ value: item.value, closePopper: close })}
                                            className={classnames("sui-advanced-select__item", {
                                                    "sui-advanced-select__item--active": props.value === item.value || (Array.isArray(props.value) && includes(props.value, item.value))
                                            })}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {props.renderFooter && (
                                <div className="sui-advanced-select__footer">{props.renderFooter(props)}</div>
                            )}
                        </div>
                    )}
                    </>
                )
            }
        />
    )
});

